export default {
  selectPreferredPartners: (state) => state.preferredPartners.partnersList,
  getRecommendedPartners: (state) => state.preferredPartners.recommendedPartners,
  enterprisesWithPartners: (state) => state.preferredPartners.enterprisesWithPartners,
  getPreferredPartnersAutoComplete: (state) => state.preferredPartners.partnersListAutoComplete,
};
